import React from 'react';

import InkVialIcon from './InkVialIcon';
import { SvgIconProps } from './SvgIcon';

const SubscriberIcon = (props: SvgIconProps) => <InkVialIcon {...props} className="tw-text-primary" />;

export default SubscriberIcon;
